import React from 'react';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

interface DateFieldProps {
  label?: string;
  name: string;
  value: string | null;
  onChange: (value: string | null) => void;
  error?: boolean;
  helperText?: string;
  disableFutureDays?: boolean;
}

const DateField: React.FC<DateFieldProps> = ({ label, name, value, onChange, error, helperText, disableFutureDays }) => {
  const disableFutureDates = (date: Dayjs | Date) => {
    return dayjs.isDayjs(date) ? date.isAfter(dayjs(), 'day') : false;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={value ? dayjs(value) : null}
        onChange={(newValue) => {
          if (dayjs.isDayjs(newValue)) {
            onChange(newValue.format('YYYY-MM-DD'));
          } else {
            onChange(null);
          }
        }}
        slotProps={{
          textField: {
            fullWidth: true,
            error: error,
            helperText: helperText,
          },
        }}
        shouldDisableDate={disableFutureDays ? disableFutureDates : undefined}
      />
    </LocalizationProvider>
  );
};

export default DateField;
